import SkeletonPulse from './SkeletonPulse';
import SessionDetailBackButton from '@/Pages/SessionDetail/SessionDetailBackButton';

/**
 * Loading placeholder for the editor's top nav bar. Mirrors the real ClipHeader layout so the
 * loading state matches the final design: back button centered over the left rail (w-20 zone),
 * title + status block, and the right-side action group with the Co-edit button after a divider.
 *
 * The back button is the REAL, functional one (not a pulse): the editor can take a while to load,
 * and the user must be able to navigate back the whole time. The rail hides its own back button
 * while this nav is mounted, so this is the only back affordance during loading.
 */
const NavBarSkeleton = () => {
  return (
    <div className="flex h-16 w-full items-center justify-between border-b border-slate-200 pr-4">
      <div className="flex items-center">
        {/* Back button — same w-20 column as the left rail so it centers over the rail icons. */}
        <div className="flex w-20 shrink-0 items-center justify-center">
          <SessionDetailBackButton inNav />
        </div>
        {/* Title + status line, aligned with the transcript heading. */}
        <div className="flex flex-col gap-1.5 pl-4">
          <SkeletonPulse classname="h-4 w-56 rounded-md" />
          <SkeletonPulse classname="h-3 w-32 rounded-md" />
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-3">
        <SkeletonPulse classname="h-8 w-32 rounded-lg" />
        <SkeletonPulse classname="size-8 rounded-lg" />
        <SkeletonPulse classname="size-8 rounded-lg" />
        <SkeletonPulse classname="h-8 w-20 rounded-lg" />
        <div className="h-6 w-px bg-slate-200" />
        <SkeletonPulse classname="h-8 w-24 rounded-lg" />
      </div>
    </div>
  );
};

export default NavBarSkeleton;
